module.exports = __webpack_public_path__ + "media/images/vector-19@2x-885032be28cae645df795a1212bf4ee7.png";